import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SkillsLightQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.SkillsFilters>;
}>;


export type SkillsLightQuery = { skills: { edges?: Array<{ node: { id: string, name: string, description?: string | null } }> | null } };


export const SkillsLightDocument = /*#__PURE__*/ gql`
    query skillsLight($filters: SkillsFilters) {
  skills(filters: $filters) {
    edges {
      node {
        id
        name
        description
      }
    }
  }
}
    `;

export function useSkillsLightQuery(options?: Omit<Urql.UseQueryArgs<SkillsLightQueryVariables>, 'query'>) {
  return Urql.useQuery<SkillsLightQuery, SkillsLightQueryVariables>({ query: SkillsLightDocument, ...options });
};